import { useQuery } from '@tanstack/react-query'
import { toast } from '@telavita-core/react-design-kit'

import { useOptimisticUpdate } from 'hooks/useOptimisticUpdate'

import { 
  fetchNotificationPreferences, 
  updateNotificationPreferences,
  IPhoneNotificationData,
  NotificationTypeEnum
} from 'services/me/preferences'

import { PHONE_NOTIFICATION_PREFERENCES } from 'settings/_reactQueryConstants'

const toastInstance = (type: 'success' | 'error', text: string) => toast({
  type,
  text,
  position: 'top-right',
  autoClose: 3000,
  closeOnClick: true,
})

export const usePhoneNotificationsService = (): IPhoneNotificationData => {
  const { data, isError, isFetchedAfterMount } = useQuery({
    queryKey: [PHONE_NOTIFICATION_PREFERENCES],
    queryFn: fetchNotificationPreferences,
    retry: false,
    refetchOnWindowFocus: false,
  })

  const { mutate: updatePhoneNotification } = useOptimisticUpdate({
    mutationFn: updateNotificationPreferences,
    onErrorActionCallback: () => toastInstance('error', 'Erro ao atualizar preferências de notificação'),
    onSuccessActionCallback: () => toastInstance('success', 'Preferências de notificação atualizadas com sucesso'),
    queryKey: PHONE_NOTIFICATION_PREFERENCES,
  })

  if (isError) {
    toastInstance('error', 'Erro ao carregar as preferências de notificações')
  }

  if (isFetchedAfterMount && data === null) {
    updateNotificationPreferences(NotificationTypeEnum.SMS)
  }

  return {
    data: data || NotificationTypeEnum.SMS,
    updatePhoneNotification
  }
}